const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgFalabella(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 .2h150v150H0V.2z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4 66.1c-3-2-6.3-3.5-9.8-4.6-1.1-.4-6.5-1.4-6.7-1.4-1.2-.1-2.4-.2-3.5-.2-6.9 0-18.3 2.3-30.3 5.6 2.2 2.1 12.7 14 24.9 14 13.5 0 21.1-7 25.4-13.4",
    fill: "#0c4531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4 66.1c-8.7 12.6-25.5 16.6-38.7 8.6h-.1c-3.1-1.9-7.1-5.1-11.5-9.1C42.9 72 15.7 84.3 15.7 98.2c0 21 60.7 37.9 81.6 37.9 21 0 37.9-17 37.9-38 0-12.9-6.8-25.1-17.8-32",
    fill: "#007935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4 60.4c1.2 0 2.4.1 3.5.2.2 0 .3 0 .5.1 1.2.1 2.3.3 3.5.5 4.4.9 8.7 2.6 12.5 5 .3-.4.6-.8.8-1.2 8.3-13.6 4-31.4-9.6-39.6C94.9 17 48.7 4.1 40.4 17.7 34 28.2 52.2 51.6 67.1 65.5c12-3.2 23.3-5.1 30.1-5.1h.2",
    fill: "#c2d100"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalabella);
export default __webpack_public_path__ + "static/media/FALABELLA.dee5fcb4221c3b0f3ada5a0c97fe412d.svg";
export { ForwardRef as ReactComponent };